var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 23
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#A5ADBA",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.972h11v-1.375H0zM5.5 0L1.577 3.923l.972.973L5.5 1.945l2.952 2.951.972-.973z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.813 9.222h1.375V.972H4.813zM5.5 20.625l-2.95-2.951-.972.972L5.5 22.57l3.924-3.924-.972-.972z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.813 21.597h1.375v-8.25H4.813z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMSIgaGVpZ2h0PSIyMyIgdmlld0JveD0iMCAwIDExIDIzIj4KICAgIDxnIGZpbGw9IiNBNUFEQkEiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMTEuOTcyaDExdi0xLjM3NUgwek01LjUgMEwxLjU3NyAzLjkyM2wuOTcyLjk3M0w1LjUgMS45NDVsMi45NTIgMi45NTEuOTcyLS45NzN6Ii8+CiAgICAgICAgPHBhdGggZD0iTTQuODEzIDkuMjIyaDEuMzc1Vi45NzJINC44MTN6TTUuNSAyMC42MjVMMi41NSAxNy42NzRsLS45NzIuOTcyTDUuNSAyMi41N2wzLjkyNC0zLjkyNC0uOTcyLS45NzJ6Ii8+CiAgICAgICAgPHBhdGggZD0iTTQuODEzIDIxLjU5N2gxLjM3NXYtOC4yNUg0LjgxM3oiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgMove as ReactComponent };